import { render, staticRenderFns } from "./register copy.vue?vue&type=template&id=0c7c66c8&scoped=true"
import script from "./register copy.vue?vue&type=script&lang=js"
export * from "./register copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7c66c8",
  null
  
)

export default component.exports